import React from "react"

import AddCircleIcon from "@mui/icons-material/AddCircle"
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import DragIndicatorIcon from "@mui/icons-material/DragIndicator"

import {useStateProviderValue} from "../context/StateProvider"

import {UPDATE_LEFT_SIDE_DATA} from "../types"

const LeftSide = () => {
	const {state, dispatch} = useStateProviderValue()
	const [leftSideData, setLeftSideData] = React.useState(state.leftSide)

	React.useEffect(() => {
		setLeftSideData(state.leftSide)
	}, [state])

	//update rightSide data state
	const updateLeftSideState = (data: typeof state.leftSide) => {
		dispatch({
			type: UPDATE_LEFT_SIDE_DATA,
			leftSide: data,
		})
	}

	//handle website row addition
	const addWebsiteRow = () => {
		//sort the website array by order
		const _websites = leftSideData.websites.sort((a, b) =>
			a.id > b.id ? 1 : -1,
		)

		//get new id by incrementing last website's id by 1
		const newId = _websites[_websites.length - 1].id + 1

		//get new order by incrementing current order
		const newOrder =
			_websites.sort((a, b) => (a.order > b.order ? 1 : -1))[
				_websites.length - 1
			].order + 1

		//push new object to website array
		_websites.push({id: newId, order: newOrder, label: "", url: ""})

		let _leftSideData = {...leftSideData} as any
		_leftSideData.websites = _websites
		updateLeftSideState(_leftSideData)
	}
	//handle website row deletion
	const removeWebsiteRow = (id: number) => {
		let _websites = leftSideData.websites
		let _leftSideData = {...leftSideData} as any

		//remove current site with id from the website array
		_websites = _websites.filter((site) => site.id !== id)
		_leftSideData.websites = _websites
		updateLeftSideState(_leftSideData)
	}

	/**** Sections for left side */

	//add new section
	const addNewSection = () => {
		//sort the website array by order
		const _sections = leftSideData.sections.sort((a, b) =>
			a.id > b.id ? 1 : -1,
		)

		//get new id by incrementing last website's id by 1
		const newId = _sections[_sections.length - 1].id + 1

		//get new order by incrementing current order
		const newOrder =
			_sections.sort((a, b) => (a.order > b.order ? 1 : -1))[
				_sections.length - 1
			].order + 1

		//push new object to website array
		_sections.push({
			id: newId,
			order: newOrder,
			title: "",
			rows: [
				{
					order: 1,
					id: 1,
					label: "",
					link: "",
				},
			],
		})

		let _leftSideData = {...leftSideData} as any
		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}

	//remove section
	const removeSection = (id: number) => {
		let _sections = leftSideData.sections
		let _leftSideData = {...leftSideData} as any

		//remove current site with id from the website array
		_sections = _sections.filter((site) => site.id !== id)
		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}

	//Add  row inside section
	const addRowsForSection = (sectionId: number) => {
		let _sections = leftSideData.sections
		let _leftSideData = {...leftSideData} as any

		//find current section index
		let index = _sections.findIndex((s) => s.id === sectionId)

		//get sorted rows
		let _rows = _sections[index].rows.sort((a, b) => (a.id > b.id ? 1 : -1))

		//new id for row
		const newId = _rows[_rows.length - 1].id + 1

		//new orderId for row
		const newOrderId =
			_rows.sort((a, b) => (a.order > b.order ? 1 : -1))[_rows.length - 1]
				.order + 1

		//push new empty row for rows
		_sections[index].rows.push({
			order: newOrderId,
			id: newId,
			label: "",
			link: "",
		})

		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}
	//remove row inside section
	const removeRowsForSection = (sectionId: number, rowId: number) => {
		let _sections = leftSideData.sections
		let _leftSideData = {...leftSideData} as any

		//find current section index
		let index = _sections.findIndex((s) => s.id === sectionId)

		//filtered rows

		let _rows = _sections[index].rows.filter((row) => row.id !== rowId)

		_sections[index].rows = _rows
		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}

	//handle data change

	//handle website row change and attached new data to left side data
	const handleWebsiteRowChange = (
		id: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		const index = leftSideData.websites.findIndex((site) => site.id === id)
		let _leftSideData = {...leftSideData} as any

		if (event.target.name === "order") {
			_leftSideData.websites[index][event.target.name] = parseInt(
				event.target.value,
			)
		} else {
			_leftSideData.websites[index][event.target.name] = event.target.value
		}
		updateLeftSideState(_leftSideData)
	}

	//handle object level data change from leftSideData object
	const handleLeftSideChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let _leftSideData = {...leftSideData} as any

		if (event.target.name === "order") {
			_leftSideData[event.target.name] = parseInt(event.target.value)
		} else {
			_leftSideData[event.target.name] = event.target.value
		}
		updateLeftSideState(_leftSideData)
	}

	//handle section main data change
	const handleSectionMainData = (
		id: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		let _sections = leftSideData.sections as any
		let _leftSideData = {...leftSideData} as any

		//find current section index
		let index = _sections.findIndex((s: any) => s.id === id)

		if (event.target.name === "order") {
			_sections[index][event.target.name] = parseInt(event.target.value)
		} else {
			_sections[index][event.target.name] = event.target.value
		}

		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}

	//handle section's inner row data
	const handleSectionRowData = (
		sectionId: number,
		rowId: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		let _sections = leftSideData.sections as any
		let _leftSideData = {...leftSideData} as any

		//find current section index
		let sectionIndex = _sections.findIndex((s: any) => s.id === sectionId)

		//find row index
		let rowIndex = _sections[sectionIndex].rows.findIndex(
			(r: any) => r.id === rowId,
		)

		if (event.target.name === "order") {
			_sections[sectionIndex].rows[rowIndex][event.target.name] = parseInt(
				event.target.value,
			)
		} else {
			_sections[sectionIndex].rows[rowIndex][event.target.name] =
				event.target.value
		}

		_leftSideData.sections = _sections
		updateLeftSideState(_leftSideData)
	}

	const [uploadImage, setUploadImage] = React.useState<any>()
	React.useEffect(() => {
		console.log("upload image", uploadImage)
	}, [uploadImage])

	//handle image update
	const handleImageUpload = (event: any) => {
		console.log("image uplaod", event?.target?.files[0])
		let urlIm = URL.createObjectURL(event?.target.files[0])
		setUploadImage(urlIm)

		//update leftSide state with image data
		let _leftSideData = {...leftSideData}
		_leftSideData.photo = urlIm
		updateLeftSideState(_leftSideData)
	}

	return (
		<div className="left-side">
			<div className="input-group">
				<label htmlFor="">Upload a photo for your CV</label>
				<input
					type="file"
					accept="image/*"
					name="imageU"
					onChange={handleImageUpload}
				/>
			</div>
			<h2 className="section-title">Contact</h2>
			<div className="input-group">
				<label htmlFor="">Phone number</label>
				<input
					type="text"
					name="phone"
					value={leftSideData.phone}
					placeholder="+358 44 0000"
					onChange={handleLeftSideChange}
				/>
			</div>
			<div className="input-group">
				<label htmlFor="">Email address</label>
				<input
					type="text"
					name="email"
					value={leftSideData.email}
					placeholder="example@gmail.com"
					onChange={handleLeftSideChange}
				/>
			</div>
			<div className="input-group">
				<label htmlFor="">Address</label>
				<input
					type="text"
					name="address"
					value={leftSideData.address}
					placeholder="Helsinki, Finland"
					onChange={handleLeftSideChange}
				/>
			</div>
			<h2 className="section-title">Website links</h2>
			<div className="website-links">
				{/** Website and links dynamic row */}
				{leftSideData.websites.map((site, index) => (
					<div className="input-website-row" key={site.id}>
						<div className="input-order">
							<DragIndicatorIcon />
							<input
								type="text"
								name="order"
								value={site.order}
								onChange={(event) => handleWebsiteRowChange(site.id, event)}
							/>
						</div>
						<div className="input-group">
							<label htmlFor="">Label</label>
							<input
								type="text"
								name="label"
								value={site.label}
								placeholder="Linkedin"
								onChange={(event) => handleWebsiteRowChange(site.id, event)}
							/>
						</div>
						<div className="input-group">
							<label htmlFor="">Link url</label>
							<input
								type="text"
								name="url"
								value={site.url}
								placeholder="https://linkedin.com/in/example"
								onChange={(event) => handleWebsiteRowChange(site.id, event)}
							/>
						</div>
						<div className="input-action">
							{leftSideData.websites.length - 1 === index ? (
								<>
									{" "}
									<RemoveCircleIcon onClick={() => removeWebsiteRow(site.id)} />
									<AddCircleIcon onClick={addWebsiteRow} />
								</>
							) : (
								<RemoveCircleIcon onClick={() => removeWebsiteRow(site.id)} />
							)}
						</div>
					</div>
				))}
			</div>

			{/** Left section row dynamic*/}

			<div className="section-left-side">
				<h2 className="section-title">Sections</h2>
				<h3>Add new section to display in the left side sections</h3>
				{leftSideData.sections.map((section, index) => (
					<div className="section-wrap" key={section.id}>
						<div className="section-wrap__head-action">
							<div className="input-order">
								<DragIndicatorIcon />
								<input
									type="text"
									name="order"
									value={section.order}
									className="input-order"
									onChange={(event) => handleSectionMainData(section.id, event)}
								/>
							</div>
							{leftSideData.sections.length > 1 && index !== 0 && (
								<span
									className="btn btn__normal"
									onClick={() => removeSection(section.id)}>
									Delete
								</span>
							)}
						</div>

						<div className="input-group">
							<label htmlFor="">Section title</label>
							<input
								type="text"
								name="title"
								placeholder="Languages"
								value={section.title}
								onChange={(event) => handleSectionMainData(section.id, event)}
							/>
						</div>
						{/** Section's inner dynamic row group */}
						{section.rows.map((row, index) => (
							<div className="input-website-row" key={row.id}>
								<div className="input-order">
									<DragIndicatorIcon />
									<input
										type="text"
										name="order"
										value={row.order}
										onChange={(event) =>
											handleSectionRowData(section.id, row.id, event)
										}
									/>
								</div>
								<div className="input-group">
									<label htmlFor="">
										{section.title ? `${section.title} label` : "Label"}
									</label>
									<input
										type="text"
										name="label"
										value={row.label}
										placeholder={
											section.title ? `${section.title}` : "English - Native"
										}
										onChange={(event) =>
											handleSectionRowData(section.id, row.id, event)
										}
									/>
								</div>
								<div className="input-group">
									<label htmlFor="">Link url</label>
									<input
										type="text"
										name="link"
										value={row.link ? row.link : ""}
										placeholder="https://linkedin.com/in/example"
										onChange={(event) =>
											handleSectionRowData(section.id, row.id, event)
										}
									/>
								</div>
								<div className="input-action">
									{section.rows.length - 1 === index ? (
										<>
											{" "}
											<RemoveCircleIcon
												onClick={() => removeRowsForSection(section.id, row.id)}
											/>
											<AddCircleIcon
												onClick={() => addRowsForSection(section.id)}
											/>
										</>
									) : (
										<RemoveCircleIcon
											onClick={() => removeRowsForSection(section.id, row.id)}
										/>
									)}
								</div>
							</div>
						))}
					</div>
				))}
			</div>

			<button className="btn btn__dark-outline mt-4" onClick={addNewSection}>
				Add new section
			</button>
		</div>
	)
}

export default LeftSide
